import React, { Fragment } from "react";
import { DonateSection, Hero } from "../../components";
import WhyDonateSection from "../../components/sections/donate/WhyDonateSection";
import { heroData } from "../../assets/data/donateData";

export default function Donate(props) {
	return (
		<Fragment>
			<Hero data={heroData} />

			<WhyDonateSection />

			<DonateSection />
		</Fragment>
	);
}
